<script setup lang="ts">
import {computed} from "vue";
import {useRoute} from "vue-router";
import {Drawer, Label, ToggleSwitch} from "@/Components/Library";
import {updateParams} from "@/Services/group-questions.ts";
import {useToast} from "primevue/usetoast";

const $route = useRoute();

const {question} = defineProps<{
    question: any;
}>();
console.log("Q", question);
const model = defineModel<boolean>();
const toast = useToast();

const saveParam = async (key: string, label: string, newValue: boolean) => {
    try {
        question.param(key, newValue);
        await updateParams($route.params.group, $route.params.question, {[key]: newValue});
        toast.add({
            severity: "success",
            summary: "Settings Updated",
            detail: `${label} have been ${newValue ? "shown" : "hidden"}`,
            life: 5000,
        });
    } catch (e) {
        console.error(e);
    }
};

const showCharts = computed({
    get: () => !!question.param("show_charts"),
    set: (value: boolean) => saveParam("show_charts", "Charts", value),
});
const showResponses = computed({
    get: () => !!question.param("show_responses"),
    set: (value: boolean) => saveParam("show_responses", "Responses", value),
});
const allowComments = computed({
    get: () => !!question.param("allow_comments"),
    set: (value: boolean) => saveParam("allow_comments", "Comments", value),
});
const allowVoiceComments = computed({
    get: () => !!question.param("allow_voice_comments"),
    set: (value: boolean) => saveParam("allow_voice_comments", "Voice Comments", value),
});
const allowVoiceResponses = computed({
    get: () => !!question.param("allow_voice_responses"),
    set: (value: boolean) => saveParam("allow_voice_responses", "Voice Responses", value),
});
</script>
<template>
    <Drawer
        v-model:visible="model"
        position="bottom"
        header="Edit question settings"
        class="relative max-h-dvh max-w-3xl overflow-y-auto"
    >
        <div class="flex flex-col gap-6 pb-6 pt-2">
            <div class="flex items-center gap-2" v-if="question.is('text') || question.is('annotation')">
                <ToggleSwitch v-model="allowVoiceResponses" input-id="allow_voice_responses" />
                <Label for="allow_voice_responses">Allow Voice Responses</Label>
            </div>
            <div class="flex items-center gap-2">
                <ToggleSwitch v-model="showResponses" input-id="show_responses" />
                <Label for="show_responses">Show Responses</Label>
            </div>
            <div class="flex items-center gap-2">
                <ToggleSwitch v-model="showCharts" input-id="show_charts" />
                <Label for="show_charts">Show Charts</Label>
            </div>
            <div class="flex items-center gap-2">
                <ToggleSwitch v-model="allowComments" input-id="allow_comments" />
                <Label for="allow_comments">Allow Comments</Label>
            </div>
            <div class="flex items-center gap-2">
                <ToggleSwitch v-model="allowVoiceComments" input-id="allow_voice_comments" />
                <Label for="allow_voice_comments">Allow Voice Comments</Label>
            </div>
        </div>
    </Drawer>
</template>
<style scoped></style>
